
import q from 'Utils/q';
import Swiper from 'Libs/swiper/swiper.js';


const progress =  (item, totalSlides, currentIndex) => {
	var fraction = (100/totalSlides) * (currentIndex + 1);
	var progressValue = document.querySelector('.component-progress__value');
	if (progressValue !== null) {
		var RADIUS = 58;
		var CIRCUMFERENCE = 2 * Math.PI * RADIUS;
		var progress = fraction / 100;
		var dashoffset = CIRCUMFERENCE * (1 - progress);
		progressValue.style.strokeDashoffset = dashoffset;
		progressValue.style.strokeDasharray = CIRCUMFERENCE;
	}
};

export default  {

	init: (item) => {

		var sliderSelector = `${item} .swiper-container`,
			paginationEl = `${item}__pagination`,
			navigationEl = `${item}__next`;

		var sliderSelectorExist = q(sliderSelector);

		if(sliderSelectorExist.length > 0) {

			var mySwiper = new Swiper (sliderSelector, {
				loop: true,
				autoplay: {
					delay: 5000,
				},
				pagination: {
					el: paginationEl,
					type: 'fraction',
				},
				navigation: {
					nextEl: navigationEl,
				}
			});

			var totalSlides = document.querySelector(`${item} .swiper-pagination-total`).innerHTML;
			progress(item, totalSlides, mySwiper.realIndex);

			mySwiper.on('slideChange', function () {
				progress(item, totalSlides, mySwiper.realIndex);
			});
		}
	}
};
